export default "__VITE_ASSET__DUylCZ1a__"